import React from "react";
import { Modal, Button, ListGroup } from "react-bootstrap";

const OrderDetailsModal = ({ order, show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Order Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {order ? (
          <div>
            <h5>Order Details</h5>
            <div className="!text-description !text-sm !font-medium mb-1"><label className="text-sm text-main font-medium">Order ID :</label> {order.order_id}</div>
            <div className="!text-description !text-sm !font-medium mb-1"><label className="text-sm text-main font-medium">Order Date :</label> {order.order_dte_tsp}</div>
            <div className="!text-description !text-sm !font-medium mb-1"><label className="text-sm text-main font-medium">Total Amount :</label> {order.order_tot_amt}</div>

            {/* Display svc_order_line details if available */}
            {order.svc_order_line && order.svc_order_line.length > 0 && (
              <>
                <h5>Service Order Lines</h5>
                <ListGroup>
                  {order.svc_order_line.map((line, index) => (
                    <ListGroup.Item key={index}>
                      <div className="!text-description !text-sm !font-medium mb-1"><strong className="text-sm text-main font-medium">Service Name:</strong> {line.svc_name}</div>
                      <div className="!text-description !text-sm !font-medium mb-1"><strong className="text-sm text-main font-medium">Quantity:</strong> {line.svc_qnty_nbr}</div>
                      <div className="!text-description !text-sm !font-medium mb-1"><strong className="text-sm text-main font-medium">Price:</strong> ${line.svc_price_amt}</div>
                      <div className="!text-description !text-sm !font-medium mb-1"><strong className="text-sm text-main font-medium">Status:</strong> {line.svc_status}</div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </>
            )}
          </div>
        ) : (
          <p>No order details available.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm btn btn-secondary" variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OrderDetailsModal;
